
import VInput from "~/components/ui/VInput"
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
    props: {
        value: {
            type: [String, Object],
            default: ''
        },
        activeDays: {
            type: Array,
            default: () => []
        },
        readonly: {
            type: Boolean,
            default: false
        },
        conditions: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: 'input'
        }
    },
    name: 'VDatePicker',
    inheritAttrs: false,
    components: {
        DatePicker,
        VInput
    },
    data() {
        return {
            input: ''
        };
    },
    computed: {
        ...mapGetters('profile', [
            'role'
        ]),
        dateListeners() {
            return {
                ...this.$listeners.date,
                input: this.handleDateInput,
                clear: this.handleDateClear
            };
        },
        dateBind() {
            return {
                valueType: 'YYYY-MM-DD',
                ...this.$attrs.date
            };
        }
    },
    methods: {
        // disabledRange(date) {
        //     return date < new Date()
        // },
        disabledDate(date) {
            if (this.activeDays.length) {
                return !this.activeDays.includes(moment(date, 'YYYY-MM-DD')._d.toLocaleDateString('ru-RU'))
            } else if (this.conditions?.length) {
                return this.conditions.some(condition => condition(date));
            }
            return null;
        },
        handleDateInput(value) {
            if (value) this.$emit('input', value);
        },
        handleInput(value) {
            this.$emit('input', value);
        },
        handleDateClear() {
            this.$emit('input', '');
        }
    }
}
